import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

/** Stores that currently accept online orders (pickup). */
export function useOrderingStores() {
  const [stores, setStores] = useState(null);
  useEffect(() => { api.get("/stores").then((r) => setStores(r.data.filter((s) => s.online_ordering))).catch(() => setStores([])); }, []);
  return { stores: stores || [], loading: stores === null };
}

/** Parses "Mon – Sun: 9:00 AM – 6:00 PM ET" → [9, 18]; falls back to 11–21. */
export function parseHours(hours) {
  const m = /(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*[–-]\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i.exec(hours || "");
  if (!m) return [11, 21];
  const to24 = (h, ap) => (Number(h) % 12) + (ap.toUpperCase() === "PM" ? 12 : 0);
  return [to24(m[1], m[3]), to24(m[4], m[6])];
}

/** "ASAP" + 15-minute pickup slots from now+20min until close. */
export function usePickupSlots(store, forAdvanceOrder = false) {
  const [openHour, closeHour] = parseHours(store?.hours);
  return useMemo(() => {
    const slots = forAdvanceOrder ? [] : [{ value: "ASAP", label: "ASAP (about 20 min)" }];
    const now = new Date();
    const start = new Date(now);
    if (forAdvanceOrder) {
      start.setHours(openHour, 0, 0, 0);
    } else {
      start.setTime(now.getTime() + 20 * 60000);
      start.setMinutes(Math.ceil(start.getMinutes() / 15) * 15, 0, 0);
      if (start.getHours() < openHour) start.setHours(openHour, 0, 0, 0);
    }
    const end = new Date(now); end.setHours(closeHour, 0, 0, 0);
    for (let t = new Date(start); t <= end; t = new Date(t.getTime() + 15 * 60000)) {
      const hh = String(t.getHours()).padStart(2, "0"), mm = String(t.getMinutes()).padStart(2, "0");
      slots.push({ value: `${hh}:${mm}`, label: t.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) });
    }
    return slots;
  }, [openHour, closeHour, forAdvanceOrder]);
}

/** Order status labels mirror Square POS so staff see the same term on both screens. */
export const ORDER_STATUS_LABEL = {
  pending: "New",
  preparing: "In progress",
  ready: "Ready",
  completed: "Completed",
  cancelled: "Canceled",
};
export const statusLabel = (s) => ORDER_STATUS_LABEL[s] || s;

